import { debounce } from "nodash"
import { useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"

export default function useDebounceDispatch(dispatchFrequencyInMs = 1000) {
    const dispatch = useDispatch()

    const debounceDispatch = useMemo(
        () => debounce((action) => dispatch(action), dispatchFrequencyInMs),
        [dispatch, dispatchFrequencyInMs]
    )

    useEffect(() => () => debounceDispatch.cancel(), [debounceDispatch])

    return {
        dispatch,
        debounceDispatch,
    }
}
